<template>
  <div :class="['mini-video', playMode]" v-show="showPage" ref="playerWindow">
    <div class="mini-video-header" @mousedown="handleDragStart($event)">
      <label>{{ playMode == "live" ? "实时浏览" : "录像回放" }}</label>
      <el-tooltip class="item" effect="dark" content="关闭" placement="top-start">
        <i class="el-icon-close close-btn" @click="handleClose"></i>
      </el-tooltip>
    </div>
    <div class="mini-video-content">
      <dh-player ref="dhPlayerWindow" videoId="dhPlayerWindow"
        :shieldClass="['el-message', 'el-message-box', 'el-message-box__wrapper', 'el-dialog', 'el-picker-panel', 'hover-blur-panel']"
        :windowType="windowType" :division="division" :showBar="showBar" @createSuccess="createSuccess"
        @realError="realError" @playbackError="playbackError" @switchStartTime="switchStartTime" @picCap="picCap"
        @videoDownloadSuccess="videoDownloadSuccess">
      </dh-player>
    </div>
  </div>
</template>

<script>
import DhPlayer from "@/components/business/dh-player/index.vue"
export default {
  name: "dhWindowPlayer", //大华播放器
  components: {
    DhPlayer
  },
  data() {
    return {
      showPage: false,
      //播放模式,直播or录像
      playMode: "live",
      // 视频器类型： 0-实时预览，3-录像回放，7-录像回放（支持倒放）
      windowType: 0,
      // 窗格数
      division: 1,
      showBar: false,
      recordCurrentObj: null,
      firstIp: '',
      videoInfo: {},
      createFlag: false
    };
  },
  // mounted() {
  //   // 插件创建
  //   this.$refs.dhPlayerWindow.initVideo()
  // },
  created() {
    let hostName = location.hostname;
    let ipIndex = hostName.indexOf('.')
    if (ipIndex !== -1) {
      this.firstIp = hostName.substring(0, ipIndex)
    }
  },
  beforeDestroy() {
    this.$refs.dhPlayerWindow.closeVideo()
    this.$refs.dhPlayerWindow.destroy()
    this.showPage = false;
    this.videoInfo = {}
    this.createFlag = false
  },
  methods: {
    //拖拽
    handleDragStart(event) {
      const startX = event.clientX;
      const startY = event.clientY;
      const pw = this.$refs.playerWindow;
      const rectBox = pw.getBoundingClientRect();
      let moveX = 0;
      let moveY = 0;
      let flag = true;
      const moveEvent = (e) => {
        if (flag) {
          moveX = e.clientX - startX;
          moveY = e.clientY - startY;
          pw.style.left = rectBox.left + moveX + "px";
          pw.style.top = rectBox.top + moveY + "px";
          this.$nextTick(() => {
            // this.resizePlugin();
          });
        }
      };
      document.body.addEventListener("mousemove", moveEvent);
      const mouseUp = () => {
        flag = false;
        document.body.removeEventListener("mousemove", moveEvent);
        document.body.removeEventListener("mouseup", mouseUp);
      };
      document.body.addEventListener("mouseup", mouseUp);
    },
    // 关闭播放
    handleClose() {
      this.$refs.dhPlayerWindow.closeVideo(0)
      this.showPage = false;
      this.videoInfo = {}
    },
    // 播放
    showWnd(info) {
      // console.log("设备参数", info)
      this.videoInfo = info
      if (info.playType == "live") {
        this.playMode = "live"
        this.windowType = 0
        this.showPage = true;
        if (this.createFlag) {
          this.queryVideoRtsp(this.videoInfo)
        }
      } else if (info.playType == "back") {
        this.playMode = "back"
        this.windowType = 3
        this.showPage = true;
        if (this.createFlag) {
          this.queryPlayBackVideoRtsp(this.videoInfo)
        }
      }
    },
    // 获取直播url并播放
    queryVideoRtsp(option) {
      const param = {
        deviceIdList: [option.playId],
        protocol: 'rtsp'
      }
      this.$fetch('/vas/video/queryRealTimeVideoRtsp.json', param).then(res => {
        if (res.success) {
          let inNetUrl = res.returnObj[0].url.substring(0, res.returnObj[0].url.indexOf('|'))
          let outNetUrl = res.returnObj[0].url.substr(res.returnObj[0].url.indexOf('|') + 1, res.returnObj[0].url.length)
          // console.log('内网', inNetUrl)
          // console.log('外网', outNetUrl)
          let rtspUrl = ''
          if (this.firstIp == '10' || this.firstIp == '172' || this.firstIp == '192') {
            rtspUrl = inNetUrl
          } else {
            rtspUrl = outNetUrl
          }
          let rtspObj = {
            channelId: res.returnObj[0].deviceId,
            path: rtspUrl
          }
          this.realByUrl(rtspObj)
        } else {
          this.$message.error(res.msgContent)
        }
      })
    },
    // 通过rtsp流播放实时预览
    realByUrl(deviceInfo) {
      let param = {
        channelId: deviceInfo.channelId,  // 通道ID 必传
        path: deviceInfo.path,  // 流地址 必传
        redirect: false, // 9090端口为true   9100端口为false 必传
      }
      this.$refs.dhPlayerWindow.realByUrl(param, 0) // 播放的窗口序号 (从0开始计数，表示第一个窗口)
    },
    switchStartTime(time) {
      // if (time.startTime <= this.recordCurrentObj.startTime || time.startTime >= this.recordCurrentObj.endTime) {
      //   this.$message.error("超出录像时间范围")
      // } else {
      //   this.recordCurrentObj.startTime = time.startTime
      //   this.queryPlayBackVideoRtsp(this.recordCurrentObj)
      //   // console.log(time, "当前拖拽到的时间点")
      // }
      this.recordCurrentObj.startTime = time.startTime * 1000
      this.queryPlayBackVideoRtsp(this.recordCurrentObj)
    },
    // 查询摄像机录像流
    queryPlayBackVideoRtsp(option) {
      this.recordCurrentObj = option
      const param = {
        deviceId: option.playId,
        startTime: option.startTime / 1000,
        endTime: option.endTime / 1000,
        protocol: 'rtsp'
      }
      this.$fetch('/vas/video/queryPlayBackVideoRtsp.json', param).then(res => {
        if (res.success) {
          let inNetUrl = res.returnObj.url.rtsp.substring(0, res.returnObj.url.rtsp.indexOf('|'))
          let outNetUrl = res.returnObj.url.rtsp.substr(res.returnObj.url.rtsp.indexOf('|') + 1, res.returnObj.url.rtsp.length)
          // console.log('内网', inNetUrl)
          // console.log('外网', outNetUrl)
          let rtspUrl = ''
          if (this.firstIp == '10' || this.firstIp == '172' || this.firstIp == '192') {
            rtspUrl = inNetUrl
          } else {
            rtspUrl = outNetUrl
          }
          let rtspObj = {
            channelId: option.thirdCameraId,
            path: rtspUrl,
            startTime: option.startTime,
            endTime: option.endTime,
          }
          this.playbackByUrl(rtspObj)
        } else {
          this.$message.error(res.msgContent)
        }
      })
    },
    // 通过rtsp播放录像回放
    playbackByUrl(deviceInfo) {
      let param = {
        channelId: deviceInfo.channelId,
        records: [], // 该参数通过调用 icc 的查询录像接口获取, 直接将数组放入即可
        path: deviceInfo.path,  // rtsp 流地址
        startTime: deviceInfo.startTime, // 传入开始时间和结束时间。
        endTime: deviceInfo.endTime, // 传入结束时间。
      }
      this.$refs.dhPlayerWindow.playbackByUrl(param, 0) // 当前要播放的窗口号
    },
    // 插件创建成功
    createSuccess() {
      this.createFlag = true
      if (this.windowType == 3) {
        this.queryPlayBackVideoRtsp(this.videoInfo)
      } else {
        this.queryVideoRtsp(this.videoInfo)
      }
    },
    createError() {
      this.createFlag = false
      this.$refs.dhPlayerWindow.initVideo()
    },
    // 播放失败
    realError(info, err) {
      this.$message({
        message: err.message,
        type: 'warning'
      });
    },
    // 回放失败
    playbackError(info, err) {
      this.$message({
        message: err.message,
        type: 'warning'
      });
    },
    // 抓图回调
    picCap(item) {
      // console.log(item)
      let time = new Date().getTime()
      var img = "data:image/png;base64," + item.base64Url
      var link = document.createElement('a');
      link.href = img;
      link.download = `抓拍图片${time}.png`;
      link.click();
    },
    // 录像下载
    videoDownloadSuccess(recordUrl) {
      this.$message.success("本地录像下载完成，地址为：" + recordUrl)
    },
  }
};
</script>

<style lang="scss" scoped>
.mini-video {
  font-size: 15px;
  user-select: none;
  display: flex;
  flex-direction: column;
  position: fixed;
  background-color: #000;
  border: #596f94 solid 0px;
  -webkit-box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.6);
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.6);
  left: 25%;
  top: 150px;
  padding: 0;
  z-index: 1001 !important;

  &.live {
    width: 600px;
    height: 400px;
  }

  &.back {
    width: 700px;
    height: 500px;
  }

  &-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #ffffff;
    background-color: #1c1f27;
    padding: 10px;
    cursor: move;

    .close-btn {
      color: #ffffff;
      cursor: pointer;
    }
  }

  &-content {
    flex: 1;
    height: 0;
    padding: 3px;
  }
}
</style>
